import { render, staticRenderFns } from "./doc-item-files.vue?vue&type=template&id=a5277e38"
import script from "./doc-item-files.vue?vue&type=script&lang=js"
export * from "./doc-item-files.vue?vue&type=script&lang=js"
import style0 from "./doc-item-files.vue?vue&type=style&index=0&id=a5277e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports